import React from "react";
import TabTemplate from "../../../_shoru_shared_library/template/TabTemplate";
import timesAndLocationsRouter from "./timesAndLocationsRouter";

function TimesAndLocationsTab(props) {

  return (
    <TabTemplate 
      router={timesAndLocationsRouter}
      passData={props.passData}
    />
  )

}

export default TimesAndLocationsTab;